import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { SpacerComponent } from '@sirius/common';
import { MediaContent } from 'matchmaking/models';
import { MatchmakingTranslateService } from 'matchmaking/services';
import { ItemSliderOrGridViewComponent } from 'shared';
@Component({
    selector: 'matchmaking-blog-posts',
    imports: [ItemSliderOrGridViewComponent, SpacerComponent],
    templateUrl: './blog-posts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './blog-posts.component.scss'
})
export class BlogPostsComponent {
    translateService = inject(MatchmakingTranslateService);
    translations = computed(() => this.translateService.translations());

    blogs = input<MediaContent[] | undefined>([]);

    cardItems = computed(() => {
        if (!this.blogs()?.length) {
            return [];
        }

        const items: any[] = [];

        this.blogs()?.forEach((story: MediaContent) => {
            story.media.forEach((media) => {
                if (!items.some((item) => item.id === media.id)) {
                    items.push(media);
                }
            });
        });

        return items;
    });
}
